import {Box} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage} from 'react-intl'
import RecommendedProducts from '../../../components/recommended-products'
import PropTypes from 'prop-types'

const Wrapper = ({children}) => (
    <Box
        background="stokkeGray.bright"
        paddingTop={10}
        paddingBottom={12}
        px={{base: 4, lg: 8}}
        className="is-pdp-recommendation"
        maxWidth="container.xxl"
        marginLeft="auto"
        marginRight="auto"
    >
        {children}
    </Box>
)
Wrapper.propTypes = {
    children: PropTypes.node
}

const ProductRecommendations = () => {
    return (
        <RecommendedProducts
            wrapper={Wrapper}
            title={
                <FormattedMessage
                    defaultMessage="Product Recommendations"
                    id="product_detail.recommended_products.title.product_recommendations"
                />
            }
            recommender="products-in-all-categories"
            trackingLabel="PLP recommendations"
        />
    )
}

export default ProductRecommendations
